const initialState = {
    products: {
        list: []
    },

    users: {
        orders: [],
        cart: [],
        isSignedIn: false,
        role: "",
        uid: "",
        username: ""
    }
};

export default initialState